import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-global" }

import BackButton from "@/components/common/BackButton.vue";
import HrAuditJournal from "@/components/hr/HrAuditJournal.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'HrEmployeeList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HrAuditJournal)
    ])
  ], 64))
}
}

})